// src/pages/Home.js
import React, {useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { getAllTokens } from '../api/token';
import { TextField, InputAdornment, Box } from '@mui/material';

import SearchIcon from '@mui/icons-material/Search';
import { Home as HomeIcon } from '@mui/icons-material';

import Layout from '../components/Layout';

const Home = () => {
  const navigate = useNavigate();
  const [tokens, setTokens] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
    getAllTokens().then((data) => {
        setTokens(data);
    });
  }, [])

  const handleRowClick = (symbol) => {
    navigate(`/token/${symbol}`);
  };

  const filteredTokens = tokens.filter((token) => token.symbol.toLowerCase().includes(searchQuery.toLowerCase()));

  return (
    <Layout title="Home" icon={<HomeIcon />}>
    <Box sx={{ 
      borderBottom: 1, 
      borderColor: 'var(--primary-color)', 
      borderRadius: 3,
      mb: 2,
    }}>
      <TextField
        fullWidth
        placeholder="Search tokens..."
        sx={{ 
          backgroundColor: 'var(--background-color)', 
          color: 'white',
          input: { 
            color: 'var(--primary-color)',
          },
          "& fieldset": { 
            border: 'none', 
           },
        }}
        variant='outlined'
        onChange={(e) => setSearchQuery(e.target.value)}
        focused
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon sx={{ color: 'var(--primary-color)' }} />
            </InputAdornment>
          ),
          disableUnderline: true,
        }}
      />
    </Box>
    <Box>
    <TableContainer component={Paper}>
      <Table>
        <TableHead sx={{ backgroundColor: 'var(--primary-color)' }}>
          <TableRow>
            <TableCell 
            sx={{ 
              color: 'var(--background-color)', 
              borderColor: 'var(--primary-color)' ,
              fontWeight: 'bold',
              fontSize: 18
            }}>
              Symbol
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody sx={{ backgroundColor: 'var(--background-color)'}}>
          {filteredTokens.map((token) => (
            <TableRow 
            key={token.symbol} 
            onClick={() => handleRowClick(token.symbol)} 
            hover
            style={{ 
              cursor: 'pointer',
            }}
            >
              <TableCell 
              sx={{ 
                color: 'var(--text-color)', 
                borderColor: 'var(--primary-color)',
                fontWeight: 'bold',
              }} >
                {token.symbol}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
    </Box>
    </Layout>
  );
};

export default Home;